import React from 'react'
import Footer from '../components/Footer'
import img from '../Img/img.png'

function Message() {
  return (
    <div>
        <div className='m-4 flex justify-center'>
        <h1 className='font-bold text-lg'>Message</h1>
      </div>
      <div className='flex justify-between mx-4 mt-7 mb-[24px]'>
        <div className='flex'>
           <img src={img} alt="" /> 
          <div className='ml-3'>
          <h3 className='font-bold'>Yoga</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
          </div>
        </div>
        <div className='flex flex-col'>
            <p className='text-gray-500 text-sm'>5.08pm</p>
          <p className='px-auto bg-lime-400 rounded-full ml-auto text-sm mt-2 w-[22px] flex justify-center'>1</p>
        </div>
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
      <div className='flex'>
           <img src={img} alt="" /> 
          <div className='ml-3'>
          <h3 className='font-bold'>Rameez</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
          </div>
        </div>
        <div className='flex flex-col'>
            <p className='text-gray-500 text-sm'>5.08pm</p>
          <p className='px-auto bg-lime-400 rounded-full ml-auto text-sm mt-2 w-[22px] flex justify-center'>1</p>
        </div>
        
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
      <div className='flex'>
           <img src={img} alt="" /> 
          <div className='ml-3'>
          <h3 className='font-bold'>Manu</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
          </div>
        </div>
        <div className='flex flex-col'>
            <p className='text-gray-500 text-sm'>5.08pm</p>
          <p className='px-auto bg-lime-400 rounded-full ml-auto text-sm mt-2 w-[22px] flex justify-center'>1</p>
        </div>
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
      <div className='flex'>
           <img src={img} alt="" /> 
          <div className='ml-3'>
          <h3 className='font-bold'>Jazz</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
          </div>
        </div>
        <div className='flex flex-col'>
            <p className='text-gray-500 text-sm'>5.08pm</p>
          <p className='px-auto bg-lime-400 rounded-full ml-auto text-sm mt-2 w-[22px] flex justify-center'>1</p>
        </div>
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
      <div className='flex'>
           <img src={img} alt="" /> 
          <div className='ml-3'>
          <h3 className='font-bold'>Pavi</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
          </div>
        </div>
        <div className='flex flex-col'>
            <p className='text-gray-500 text-sm'>5.08pm</p>
          <p className='px-auto bg-lime-400 rounded-full ml-auto text-sm mt-2 w-[22px] flex justify-center'>1</p>
        </div>
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
      <div className='flex'>
           <img src={img} alt="" /> 
          <div className='ml-3'>
          <h3 className='font-bold'>Chaal</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
          </div>
        </div>
        <div className='flex flex-col'>
            <p className='text-gray-500 text-sm'>5.08pm</p>
          <p className='px-auto bg-lime-400 rounded-full ml-auto text-sm mt-2 w-[22px] flex justify-center'>1</p>
        </div>
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
      <div className='flex'>
           <img src={img} alt="" /> 
          <div className='ml-3'>
          <h3 className='font-bold'>KC</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
          </div>
        </div>
        <div className='flex flex-col'>
            <p className='text-gray-500 text-sm'>5.08pm</p>
          <p className='px-auto bg-lime-400 rounded-full ml-auto text-sm mt-2 w-[22px] flex justify-center'>1</p>
        </div>
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
      <div className='flex'>
           <img src={img} alt="" /> 
          <div className='ml-3'>
          <h3 className='font-bold'>Akshayal</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
          </div>
        </div>
        <div className='flex flex-col'>
            <p className='text-gray-500 text-sm'>5.08pm</p>
          <p className='px-auto bg-lime-400 rounded-full ml-auto text-sm mt-2 w-[22px] flex justify-center'>1</p>
        </div>
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
      <div className='flex'>
           <img src={img} alt="" /> 
          <div className='ml-3'>
          <h3 className='font-bold'>Vijay</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
          </div>
        </div>
        <div className='flex flex-col'>
            <p className='text-gray-500 text-sm'>5.08pm</p>
          <p className='px-auto bg-lime-400 rounded-full ml-auto text-sm mt-2 w-[22px] flex justify-center'>1</p>
        </div>
        
      </div>
      <div className='flex justify-between mx-4 mb-[24px]'>
      <div className='flex'>
           <img src={img} alt="" /> 
          <div className='ml-3'>
          <h3 className='font-bold'>Yoga</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
          </div>
        </div>
        <div className='flex flex-col'>
            <p className='text-gray-500 text-sm'>5.08pm</p>
          <p className='px-auto bg-lime-400 rounded-full ml-auto text-sm mt-2 w-[22px] flex justify-center'>1</p>
        </div>
        
      </div>
      
      <Footer active={'message'}/>
    </div>
  )
}

export default Message